import { defineStore } from 'pinia';
import cloneDeep from 'lodash.clonedeep';
import { StateSnapshot } from '@/typings/historyV2';

export const useStore = defineStore({
  id: 'historyV2',

  state: () => {
    return {
      pointer: -1,
      history: [] as StateSnapshot[],
    };
  },
  getters: {
    isUndoPossible(): boolean {
      return this.history.length > 0 && this.pointer > 0;
    },
    isRedoPossible(): boolean {
      return this.history.length > 0 && this.pointer < this.history.length - 1;
    },
  },
  actions: {
    recordHistory(snapshot: StateSnapshot) {
      if (this.pointer !== this.history.length - 1) {
        this.history = this.history.splice(0, this.pointer + 1);
      }
      this.history.push(snapshot);
      this.pointer += 1;
    },
    undo(): StateSnapshot | null {
      if (this.pointer >= 0) {
        this.pointer -= 1;
        return this.history[this.pointer];
      }
      return null;
    },
    redo(): StateSnapshot | null {
      if (this.pointer < this.history.length) {
        this.pointer += 1;
        return this.history[this.pointer];
      }
      return null;
    },
  },
});
